export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const PAGING_INFO = 'PAGING_INFO';
export const POPUP_SET_FORM = 'POPUP_SET_FORM';
export const POPUP_STATE_INIT = 'POPUP_STATE_INIT';
export const SELECTED_PARAM = 'SELECTED_PARAM';

export default { STATE_INIT, DEFAULT_ASSIGN, SEARCH_PARAM, PAGING_INFO, POPUP_SET_FORM, POPUP_STATE_INIT, SELECTED_PARAM };
